import React from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Grid } from 'planoplan-ui-kit/core/helpers/grid';
import { Rhytm } from 'planoplan-ui-kit/core/helpers/rhytm';
import {textSize, Points, marginLevel, common} from '@styles';
import { Title } from '@components/Title';
import { Breadcrumbs } from '@components/Breadcrumbs';
import { Banner, Widget } from '../Content';
import { useTranslations } from '@libs/translations';
import { IEye } from 'planoplan-ui-kit/core/icons/i-eye';
import { ILove } from 'planoplan-ui-kit/core/icons/i-love';
import { IRooms } from 'planoplan-ui-kit/core/icons/i-rooms';
import { IArea } from 'planoplan-ui-kit/core/icons/i-area';
import { GALLERY_PATH } from '@constants';
import { Mixins } from "planoplan-ui-kit/core/mixins";

export const Content = ({ content }) => {
  const { title, image, room, area, text, id_widget, file_widget, tags_room, tags_style } = content;
  const translations = useTranslations();
  const formattedText = text.replace(/ style=".*?"/ig, '');

  return (
    <Container>
      <Main>
        <Header>
          <Breadcrumbs
            links={[
              { href: `/${GALLERY_PATH}/`, name: translations.t('site.galleryProjects.pageTitle') },
              { href: '', name: title },
            ]}
          />
          <Title align="left">{title}</Title>
          <Tags>
            {tags_style && tags_style.map((tag) => (
              <Tag key={tag.id}><a>{tag.name.toLowerCase()}</a></Tag>
            ))}

            {tags_room && tags_room.map((tag) => (
              <Tag key={tag.id}><a>{tag.name.toLowerCase()}</a></Tag>
            ))}
          </Tags>

          <Information>
            <InfoWrap>
              <Info><IRooms width="16px" height="16px" fill={Colors.black} /><span>{translations.t(room)}</span></Info>
              <Info><IArea width="16px" height="16px" fill={Colors.black} /><span>{area}m&sup2;</span></Info>
            </InfoWrap>
            {/*<InfoWrap>
              <Info><IEye width="16px" height="16px" fill={Colors.black} /><span>365</span></Info>
              <Info><ILove width="16px" height="16px" fill={Colors.black} /><span>30</span></Info>
            </InfoWrap>*/}
          </Information>

          <Widget id={id_widget} image={image} alt={title}/>
          <Text dangerouslySetInnerHTML={{__html: formattedText}}/>
        </Header>
      </Main>

      {/*<Banner fileWidget={file_widget} title={title} />*/}
    </Container>
  );
};

const Container = styled.section`
  ${marginLevel('bottom', 'frog_green')};
  ${Grid.row};
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
`;

const Main = styled.article`
  ${Grid.post(2)};
  ${Grid.push(2)};
  ${Grid.column(32, 36)};

  @media ${Points.laptop} {
    ${Grid.column(23, 36)};
  }
`;

const Header = styled.div`
  @media ${Points.tablet_portrait} {
    ${Grid.prefix(1, 32)};
  }

  @media ${Points.laptop} {
    ${Grid.prefix(1, 23)};
  }
`;

const Tags = styled.ul`
  list-style: none;
  display: flex;
  padding: 0;
  margin: 0 0 -4px;
  flex-wrap: wrap;
`;

const Tag = styled.li`
  ${textSize('p3')};
  margin-right: 4px;
  margin-bottom: 4px;
  
  a {
    display: block; 
    padding: 4px 10px;
    border: 1px solid ${Colors.coal};
    border-radius: 20px; 
  }
`;

const Information = styled.div`
  ${marginLevel('top', 'whisper')};
  ${textSize('p3')};
  display: flex;
`;

const InfoWrap = styled.div`
  margin-right: 21px;
  display: flex;
`;

const Info = styled.div`
  margin-right: 10px;
  display: flex;
  align-items: center;
  
  span {
    margin-left: 2px;
  }
`;

const Text = styled.div`
  ${textSize('p')};
  ${marginLevel('top', 'electric_blue')};
  ${marginLevel('bottom', 'dark_cream')};

  @media ${Points.tablet_portrait} {
    ${Grid.suffix(2, 32)};
  }
  
  color: ${Colors.black};
  
  ol {
    ${Mixins.resetList()};
  }

  ul {
    ${common('listBig')};
    ${marginLevel('both', 'azure')};
  }

  p,
  li {
    ${textSize('p1_long_with_spacing')};
  }
  
  li {
    padding-left: 26px;
    position: relative;
  }

  b {
    font-weight: 500;
  }

  a {
    ${common('a')};
  }
  
  h2,h3,h4 {
    font-weight: 400;
    ${marginLevel('both', 'azure')};
  }
`;
